module.exports = __webpack_public_path__ + "img/copy.b0f81549.png";